import { getScheduleItemsFromListResult } from '@/lib/automationSchedules/scheduleState.js';
import resolveCollectionScopeCompanyId from '@/redux/reducers/pieveReducer/resolveCollectionScopeCompanyId.js';

const replaceScheduleItemsFromRequestPayload = ({ state, payload } = {}) => {
  const nextScopeCompanyId = resolveCollectionScopeCompanyId({
    payload,
    state,
    ownerKey: 'scheduleItemsScopeCompanyId'
  });

  return {
    ...state,
    scheduleItems: getScheduleItemsFromListResult(payload?.data || payload),
    scheduleItemsScopeCompanyId: nextScopeCompanyId
  };
};

export default replaceScheduleItemsFromRequestPayload;
